import React from 'react';
import { Avatar, Button, Spin, List } from "antd";
import sumBy from 'lodash/sumBy'

export default class MappingItem extends React.Component {
  onRemove = () => {
    this.props.onRemoveMapping(this.props.item);
  };

  render() {
    const { item } = this.props;
    const isDone = item.status === "done";
    const isPending = item.status === 'pending';
    const isUploading = item.status === 'uploading';
    const error = item.error;
    let total = item.images.length * 100;
    let completed = sumBy(item.images, 'percent');
    const pc = (completed * 100) / total;

    let avatar = (
      <Avatar
        size="small"
        style={{ backgroundColor: "#9e9e9e" }}
        icon="hourglass"
      />
    );

    if (isDone) {
      avatar = (
        <Avatar
          size="small"
          style={{ backgroundColor: "#87d068" }}
          icon="check"
        />
      )
    } else if (error) {
      avatar = (
        <Avatar
          size="small"
          style={{ backgroundColor: "red" }}
          icon="exclamation"
        />
      )
    }

    return (
      <Spin spinning={isUploading} tip={`Uploading... ${pc.toFixed(0)}%`}>
        <List.Item
          actions={[
            <Button
              type="danger"
              icon="delete"
              onClick={this.onRemove}
            />
          ]}
        >
          <List.Item.Meta
            avatar={avatar}
            title={item.name}
            description={
              <div>
                <div>
                  {item.images.length} files | {item.catalogName} |{" "}
                  {item.product_size} | {item.quantity} each
                </div>
                {item.status === "error" && (
                  <div style={{ color: "red" }}>{item.error}</div>
                )}
              </div>
            }
          />
        </List.Item>
      </Spin>
    );
  }
}